import React from "react";

export interface IconProps {
  color?: string;
  size?: number;
}

export const HomeIcon: React.FC<IconProps> = ({
  color = "white",
  size = 24,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon">
      <path
        id="Vector"
        d="M10 18H14"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M2.35139 13.2135C1.99837 10.9162 1.82186 9.76763 2.25617 8.74938C2.69047 7.73112 3.65403 7.03443 5.58114 5.64106L7.02099 4.6C9.41829 2.86667 10.6169 2 12 2C13.3831 2 14.5817 2.86667 16.979 4.6L18.4189 5.64106C20.346 7.03443 21.3095 7.73112 21.7438 8.74938C22.1781 9.76763 22.0016 10.9162 21.6486 13.2135L21.3476 15.1724C20.8471 18.4289 20.5969 20.0572 19.429 21.0286C18.2611 22 16.5537 22 13.1388 22H10.8612C7.44633 22 5.73891 22 4.571 21.0286C3.40309 20.0572 3.15287 18.4289 2.65243 15.1724L2.35139 13.2135Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const DocumentIcon: React.FC<IconProps> = ({
  color = "white",
  size = 24,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon">
      <path
        d="M7 3.75H12.5858C12.851 3.75 13.1054 3.85536 13.2929 4.04289L18.2071 8.95711C18.3946 9.14464 18.5 9.39899 18.5 9.66421V19.25C18.5 20.3546 17.6046 21.25 16.5 21.25H7.5C6.39543 21.25 5.5 20.3546 5.5 19.25V5.75C5.5 4.64543 6.39543 3.75 7.5 3.75Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 3.5V7.75C12.75 8.30228 13.1977 8.75 13.75 8.75H18"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12.5H15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9 16H15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const CredentialsIcon: React.FC<IconProps> = ({
  color = "white",
  size = 24,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon">
      <path
        d="M7 12.5C7 11.1193 8.11929 10 9.5 10H14.5C15.8807 10 17 11.1193 17 12.5C17 13.8807 15.8807 15 14.5 15H9.5C8.11929 15 7 13.8807 7 12.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12.5H12.01"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 2V6"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 18V22"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15.8891 4.11091L13.5 6.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10.5 6.5L8.11091 4.11091"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15.8891 20.8891L13.5 18.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10.5 18.5L8.11091 20.8891"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const CompanyIcon: React.FC<IconProps> = ({
  color = "white",
  size = 24,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon">
      <path
        id="Vector"
        d="M2.57956 8.62505C2.50886 8.03528 2.47351 7.74039 2.52323 7.499C2.6651 6.81015 3.27111 6.25159 4.07871 6.06529C4.36172 6 4.717 6 5.42757 6H18.5724C19.283 6 19.6383 6 19.9213 6.06529C20.7289 6.25159 21.3349 6.81015 21.4768 7.499C21.5265 7.74039 21.4911 8.03528 21.4204 8.62505C21.2584 9.97669 20.4991 10.716 19.0512 11.1423L14.88 12.3703C13.4541 12.7901 12.7411 13 12 13C11.2589 13 10.5459 12.7901 9.11996 12.3703L4.94882 11.1423C3.50094 10.7161 2.7416 9.97669 2.57956 8.62505Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        id="Vector_2"
        d="M3.46283 10.5L3.26658 12.7757C2.91481 16.855 2.73892 18.8947 3.86734 20.1974C4.99576 21.5 6.93851 21.5 10.824 21.5H13.176C17.0615 21.5 19.0042 21.5 20.1327 20.1974C21.2611 18.8947 21.0852 16.855 20.7334 12.7757L20.5372 10.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M15.5 5.5L15.4227 5.23509C15.0377 3.91505 14.8452 3.25503 14.3869 2.87752C13.9286 2.5 13.3199 2.5 12.1023 2.5H11.8977C10.6801 2.5 10.0714 2.5 9.61309 2.87752C9.15478 3.25503 8.96228 3.91505 8.57727 5.23509L8.5 5.5"
        stroke={color}
        strokeWidth="1.5"
      />
    </g>
  </svg>
);

export const CampaignIcon: React.FC<IconProps> = ({
  color = "white",
  size = 24,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon">
      <path
        id="Vector"
        d="M14.9263 2.91103L8.27352 6.10452C7.76151 6.35029 7.21443 6.41187 6.65675 6.28693C6.29177 6.20517 6.10926 6.16429 5.9623 6.14751C4.13743 5.93912 3 7.38342 3 9.04427V9.95573C3 11.6166 4.13743 13.0609 5.9623 12.8525C6.10926 12.8357 6.29178 12.7948 6.65675 12.7131C7.21443 12.5881 7.76151 12.6497 8.27352 12.8955L14.9263 16.089C16.4534 16.8221 17.217 17.1886 18.0684 16.9029C18.9197 16.6172 19.2119 16.0041 19.7964 14.778C21.4012 11.4112 21.4012 7.58885 19.7964 4.22196C19.2119 2.99586 18.9197 2.38281 18.0684 2.0971C17.217 1.8114 16.4534 2.17794 14.9263 2.91103Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M11.4581 20.7709L9.96674 22C6.60515 19.3339 7.01583 18.0625 7.01583 13H8.14966C8.60978 15.8609 9.69512 17.216 11.1927 18.197C12.1152 18.8012 12.3054 20.0725 11.4581 20.7709Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M7.5 12.5V6.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const MetricsIcon: React.FC<IconProps> = ({
  color = "white",
  size = 24,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon">
      <path
        id="Vector"
        d="M7 17V13"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        id="Vector_2"
        d="M12 17V7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        id="Vector_3"
        d="M17 17V11"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        id="Vector_4"
        d="M2.5 12C2.5 7.52166 2.5 5.28249 3.89124 3.89124C5.28249 2.5 7.52166 2.5 12 2.5C16.4783 2.5 18.7175 2.5 20.1088 3.89124C21.5 5.28249 21.5 7.52166 21.5 12C21.5 16.4783 21.5 18.7175 20.1088 20.1088C18.7175 21.5 16.4783 21.5 12 21.5C7.52166 21.5 5.28249 21.5 3.89124 20.1088C2.5 18.7175 2.5 16.4783 2.5 12Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const UserIcon: React.FC<IconProps> = ({
  color = "white",
  size = 24,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon">
      <path
        id="Vector"
        d="M7.78256 17.1112C6.68218 17.743 3.79706 19.0331 5.55429 20.6474C6.41269 21.436 7.36872 22 8.57068 22H15.4293C16.6313 22 17.5873 21.436 18.4457 20.6474C20.2029 19.0331 17.3178 17.743 16.2174 17.1112C13.6371 15.6296 10.3629 15.6296 7.78256 17.1112Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M15.5 10C15.5 11.933 13.933 13.5 12 13.5C10.067 13.5 8.5 11.933 8.5 10C8.5 8.067 10.067 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        id="Vector_3"
        d="M2.854 16C2.30501 14.7664 2 13.401 2 11.9646C2 6.46129 6.47715 2 12 2C17.5228 2 22 6.46129 22 11.9646C22 13.401 21.695 14.7664 21.146 16"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const VideoIcon: React.FC<IconProps> = ({
  color = "white",
  size = 24,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon">
      <path
        id="Vector"
        d="M11 8H13"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        id="Vector_2"
        d="M2 11C2 7.70017 2 6.05025 3.02513 5.02513C4.05025 4 5.70017 4 9 4H10C13.2998 4 14.9497 4 15.9749 5.02513C17 6.05025 17 7.70017 17 11V13C17 16.2998 17 17.9497 15.9749 18.9749C14.9497 20 13.2998 20 10 20H9C5.70017 20 4.05025 20 3.02513 18.9749C2 17.9497 2 16.2998 2 13V11Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        id="Vector_3"
        d="M17 8.90585L17.1259 8.80196C19.2417 7.05623 20.2996 6.18336 21.1498 6.60482C22 7.02628 22 8.42355 22 11.2181V12.7819C22 15.5765 22 16.9737 21.1498 17.3952C20.2996 17.8166 19.2417 16.9438 17.1259 15.198L17 15.0941"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const ComputerIcon: React.FC<IconProps> = ({
  color = "white",
  size = 24,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon">
      <path
        id="Vector"
        d="M4.75 15V7C4.75 5.11438 4.75 4.17157 5.33579 3.58579C5.92157 3 6.86438 3 8.75 3H11.75M20.75 15V14.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M18.75 2C20.6356 2 21.5784 2 22.1642 2.58579C22.75 3.17157 22.75 4.11438 22.75 6V8C22.75 9.88562 22.75 10.8284 22.1642 11.4142C21.5784 12 20.6356 12 18.75 12C16.8644 12 15.9216 12 15.3358 11.4142C14.75 10.8284 14.75 9.88562 14.75 8V6C14.75 4.11438 14.75 3.17157 15.3358 2.58579C15.9216 2 16.8644 2 18.75 2Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        id="Vector_3"
        d="M18.75 9H18.759"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M4.24762 16.0154L4.76953 15H20.7018L21.2523 16.0154C22.6952 18.677 23.0546 20.0077 22.5061 21.0039C21.9577 22 20.5036 22 17.5954 22H7.90462C4.99642 22 3.54231 22 2.99387 21.0039C2.44543 20.0077 2.80474 18.677 4.24762 16.0154Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const MouseIcon: React.FC<IconProps> = ({
  color = "white",
  size = 24,
}) => (
  <svg
    width={(size * 25) / 24}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon">
      <path
        id="Vector"
        d="M14 5.5V2M14 12V9"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M14 22C20 22 21.5 17.49 21.5 12C21.5 6.50998 20 2 14 2C7.99993 2 6.5 6.50996 6.5 12C6.5 17.49 7.99993 22 14 22Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        id="Vector_3"
        d="M15.5 7C15.5 6.53406 15.5 6.30109 15.4239 6.11732C15.3224 5.87229 15.1277 5.67761 14.8827 5.57612C14.6989 5.5 14.4659 5.5 14 5.5C13.5341 5.5 13.3011 5.5 13.1173 5.57612C12.8723 5.67761 12.6776 5.87229 12.5761 6.11732C12.5 6.30109 12.5 6.53406 12.5 7V7.5C12.5 7.96594 12.5 8.19891 12.5761 8.38268C12.6776 8.62771 12.8723 8.82239 13.1173 8.92388C13.3011 9 13.5341 9 14 9C14.4659 9 14.6989 9 14.8827 8.92388C15.1277 8.82239 15.3224 8.62771 15.4239 8.38268C15.5 8.19891 15.5 7.96594 15.5 7.5V7Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        id="Vector_4"
        d="M6.5 12H21.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_5"
        d="M5.5 3.16746L5.11888 2M4.52867 5.56746L3.5 6"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const MoneyIcon: React.FC<IconProps> = ({
  color = "white",
  size = 24,
}) => (
  <svg
    width={(size * 25) / 24}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon">
      <path
        id="Vector"
        d="M19.9953 13C20.7862 11.8662 21.25 10.4872 21.25 9C21.25 5.13401 18.116 2 14.25 2C10.384 2 7.25 5.134 7.25 9C7.25 10.0736 7.49169 11.0907 7.92363 12"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M14.25 6C13.1454 6 12.25 6.67157 12.25 7.5C12.25 8.32843 13.1454 9 14.25 9C15.3546 9 16.25 9.67157 16.25 10.5C16.25 11.3284 15.3546 12 14.25 12M14.25 6C15.1208 6 15.8616 6.4174 16.1362 7M14.25 6V5M14.25 12C13.3792 12 12.6384 11.5826 12.3638 11M14.25 12V13"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        id="Vector_3"
        d="M3.25 14H5.64482C5.93897 14 6.22908 14.0663 6.49217 14.1936L8.53415 15.1816C8.79724 15.3089 9.08735 15.3751 9.3815 15.3751H10.4241C11.4325 15.3751 12.25 16.1662 12.25 17.142C12.25 17.1814 12.223 17.2161 12.1838 17.2269L9.64287 17.9295C9.18707 18.0555 8.699 18.0116 8.275 17.8064L6.09211 16.7503M12.25 16.5L16.8428 15.0889C17.657 14.8352 18.5371 15.136 19.0471 15.8423C19.4159 16.3529 19.2657 17.0842 18.7285 17.3942L11.2129 21.7305C10.7349 22.0063 10.1709 22.0736 9.64516 21.9176L3.25 20.0199"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const EditIcon: React.FC<IconProps> = ({
  color = "white",
  size = 24,
}) => (
  <svg
    width={size}
    height={(size * 17) / 16}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.95 3.57006L11.61 2.91006C12.1568 2.36331 13.0432 2.36331 13.59 2.91006C14.1367 3.45682 14.1367 4.34329 13.59 4.89005L12.93 5.55004M10.95 3.57006L6.51043 8.0096C6.17209 8.348 5.93207 8.77186 5.81602 9.23606L5.33337 11.1667L7.26397 10.684C7.72817 10.568 8.15204 10.3279 8.49044 9.9896L12.93 5.55004M10.95 3.57006L12.93 5.55004"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M12.6666 9.50016C12.6666 11.6918 12.6666 12.7876 12.0613 13.5252C11.9505 13.6602 11.8267 13.784 11.6917 13.8948C10.9541 14.5002 9.85827 14.5002 7.6666 14.5002H7.33333C4.81917 14.5002 3.56211 14.5002 2.78106 13.7191C2.00002 12.9381 2 11.681 2 9.16683V8.8335C2 6.64184 2 5.54602 2.60529 4.80846C2.71611 4.67343 2.83993 4.54961 2.97496 4.43879C3.71253 3.8335 4.80835 3.8335 7 3.8335"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
